// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filesUploadInfo{ 
    margin: 1rem 0;
    background-color: #FFF9F2;
    border: 1px solid #FF973C;
    border-radius: 5px;
    padding: 0.5% 1.5%;
    @media screen and (orientation:landscape) {
        max-width: 50%;
    }
    @media screen and (orientation:portrait) {
        max-width: 400px;
    }
}
.filesUploadInfo_image_a{
    height:5vh;
    max-height: 50px;
    object-fit: contain;
    margin: 0 0 2% 2%;
}

.filesUploadInfo_row{
    display: flex;
    width:100%;
    align-items: center;
}

.filesUploadInfo_info_green{
    border: 1px solid #138808;
    background-color: #F1FFEC;
}

.filesUploadInfo_info_red{
    border: 1px solid #EB7464;
    background-color: #FCDFDB;
}

.filesUploadInfo_info_row{
    height: max-content;
    margin-bottom: 2%;
    border-radius: 5px;
}

.filesUploadInfo_image_border_b{
    height: 100%;
    width:20%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #138808;

}

.filesUploadInfo_image_b{
    height:10vh;
    max-height: 65px;
    object-fit: contain;
    @media screen and (orientation:portrait){
        width: 100%;
    }
}

.filesUploadInfo_text_border_b{
    height: 100%;
    width:80%;
    display: flex;
    align-items: center;
    color: #138808;
}

.filesUploadInfo_image_border_c{
    height: 100%;
    width:20%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #EB7464;
}

.filesUploadInfo_image_c{
    height:10vh;
    max-height: 65px;
    object-fit: contain;
    @media screen and (orientation:portrait){
        width: 100%;
    }
}

.filesUploadInfo_text_border_c{
    height: 100%;
    width:80%;
    display: flex;
    align-items: center;
    color: #EB7464;
}

.filesUploadInfo_row h4{
    padding: 0 2%;
    margin:0;
} `, "",{"version":3,"sources":["webpack://./src/components/fields/userInput/filesUpload/filesUploadInfo/styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;;AAEnC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;QACI,WAAW;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;QACI,WAAW;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ","sourcesContent":[".filesUploadInfo{ \n    margin: 1rem 0;\n    background-color: #FFF9F2;\n    border: 1px solid #FF973C;\n    border-radius: 5px;\n    padding: 0.5% 1.5%;\n    @media screen and (orientation:landscape) {\n        max-width: 50%;\n    }\n    @media screen and (orientation:portrait) {\n        max-width: 400px;\n    }\n}\n.filesUploadInfo_image_a{\n    height:5vh;\n    max-height: 50px;\n    object-fit: contain;\n    margin: 0 0 2% 2%;\n}\n\n.filesUploadInfo_row{\n    display: flex;\n    width:100%;\n    align-items: center;\n}\n\n.filesUploadInfo_info_green{\n    border: 1px solid #138808;\n    background-color: #F1FFEC;\n}\n\n.filesUploadInfo_info_red{\n    border: 1px solid #EB7464;\n    background-color: #FCDFDB;\n}\n\n.filesUploadInfo_info_row{\n    height: max-content;\n    margin-bottom: 2%;\n    border-radius: 5px;\n}\n\n.filesUploadInfo_image_border_b{\n    height: 100%;\n    width:20%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-right: 1px solid #138808;\n\n}\n\n.filesUploadInfo_image_b{\n    height:10vh;\n    max-height: 65px;\n    object-fit: contain;\n    @media screen and (orientation:portrait){\n        width: 100%;\n    }\n}\n\n.filesUploadInfo_text_border_b{\n    height: 100%;\n    width:80%;\n    display: flex;\n    align-items: center;\n    color: #138808;\n}\n\n.filesUploadInfo_image_border_c{\n    height: 100%;\n    width:20%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid #EB7464;\n}\n\n.filesUploadInfo_image_c{\n    height:10vh;\n    max-height: 65px;\n    object-fit: contain;\n    @media screen and (orientation:portrait){\n        width: 100%;\n    }\n}\n\n.filesUploadInfo_text_border_c{\n    height: 100%;\n    width:80%;\n    display: flex;\n    align-items: center;\n    color: #EB7464;\n}\n\n.filesUploadInfo_row h4{\n    padding: 0 2%;\n    margin:0;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
